import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal
} from '@angular/core';
import { DialogWrapperComponent } from '../../wrappers/dialog-wrapper/dialog-wrapper.component';
import { BaseDialogDirective } from '../../base/base-dialog.directive';
import { HappyStoreSelectionService } from '../../../../core/services/happy/happy-store-selection.service';
import {
  HappyApiStore,
  HappyStoresApiService
} from '../../../../core/services/happy/happy-stores-api.service';

export interface StorePickerDialogData {
  title: string;
  stores?: HappyApiStore[] | null;
}

export interface StorePickerDialogResult {
  index: number;
  domain: string;
  apiKey: string;
}

@Component({
  selector: 'app-store-picker-dialog',
  templateUrl: './store-picker-dialog.component.html',
  styleUrl: './store-picker-dialog.component.scss',
  imports: [DialogWrapperComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StorePickerDialogComponent
  extends BaseDialogDirective<StorePickerDialogResult, StorePickerDialogData>
  implements OnInit
{
  private readonly storeSelection = inject(HappyStoreSelectionService);
  private readonly storesApi = inject(HappyStoresApiService);

  protected readonly stores: WritableSignal<HappyApiStore[]> = signal([]);
  protected readonly isLoading: WritableSignal<boolean> = signal(true);

  ngOnInit(): void {
    const preloaded = this.dialogData?.stores;
    if (preloaded && preloaded.length > 0) {
      this.stores.set(preloaded);
      this.isLoading.set(false);
      return;
    }

    this.storesApi.fetchActiveInstantOrderingStores().subscribe({
      next: (apiStores) => {
        this.stores.set(apiStores);
        this.isLoading.set(false);

        if (apiStores.length === 1) {
          this.pickStore(apiStores[0]);
        }
      },
      error: () => {
        this.isLoading.set(false);
      }
    });
  }

  protected pick(index: number): void {
    const store = this.stores()[index];
    if (!store) {
      return;
    }
    this.pickStore(store);
  }

  private pickStore(store: HappyApiStore): void {
    const envIndex = this.storeSelection.findIndexByDomain(store.domain);
    this.closeDialog({
      index: envIndex >= 0 ? envIndex : 0,
      domain: store.domain,
      apiKey: store.api_key
    });
  }
}
